import React, {useRef, useEffect, useState, Fragment} from 'react';
import {
  MapContainer,
  TileLayer,
  Marker,
  Polyline,
  Popup,
  Polygon,
  Rectangle,
  FeatureGroup,
  Circle, LayersControl, LayerGroup
} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import customIcon from 'leaflet/dist/images/marker-icon.png';
import 'leaflet/dist/images/marker-shadow.png';

import L from 'leaflet';
import carIcon from "./imgTaxi.png";
import busIcon from "./imgBus.png";


const MapShow = ({data}) => {

  const center = [36.8439370, 54.4080510]
  const position = [36.8439370, 54.4080510]


  return (
    <div>
      <MapContainer center={center} zoom={13} scrollWheelZoom={true} style={{height: '80vh', zIndex: '3'}}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {data && data.length > 0 &&
          <>
            {data.map((item, indexKey) => {

              const timeStampToData = new Date(parseFloat(item.timestamp*1000)).toLocaleDateString('fa-IR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                calendar: 'persian',
                hour12: false,
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
              });

              const myCarIcon = L.icon({
                iconUrl: carIcon,     // Path to your car icon image
                iconSize: [32, 32],   // Size of the icon image
                iconAnchor: [16, 16]  // Anchor point of the icon relative to its position
              });
              const myBusIcon = L.icon({
                iconUrl: busIcon,     // Path to your car icon image
                iconSize: [32, 32],   // Size of the icon image
                iconAnchor: [16, 16]  // Anchor point of the icon relative to its position
              });

              const vehicleIcon = item.type === "bus" ? myBusIcon :
                item.type === "taxi" ? myCarIcon : myCarIcon

              return <Fragment key={indexKey}>
                <Marker
                  position={[item.LAT_A, item.LONG_A]}
                  // position={[12,11 ]}
                  icon={vehicleIcon}


                >
                  <Popup>
                    راننده: {item.name}
                    <br/>
                    پلاک: {item.pelak}
                    <br/>
                    نوع: {item.type}
                    <br/>
                    <br/>
                    {!!timeStampToData &&
                      <> زمان: {timeStampToData}</>
                     }
                    <br/>

                  </Popup>
                </Marker>
              </Fragment>
            })}
          </>
        }
      </MapContainer>
    </div>
  );
};

export default MapShow;
